import {
   makeStyles,
   Button,
   Drawer,
   FormControl,
   Grid,
   IconButton,
   InputAdornment,
   InputLabel,
   OutlinedInput
} from '@material-ui/core'
import React, { useState } from 'react'
import SecurityAdministrationLayout from '../../commons/SecurityAdministrationLayout'
import InfoIcon from '@material-ui/icons/Info'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import DragZoneCard from '../../commons/DragZoneCard'
import CloseIcon from '@material-ui/icons/Close'
import { postToApi } from 'actions'
import Spinner from '../../commons/Spinner'
import { useStateValue } from 'context/store'
import { useHasOperation } from 'hooks/useHasOperation'
import { OPERACIONES_ROLES } from 'utils/constants'

const useStyles = makeStyles(() => ({
   formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      margin: '10px auto 10px'
   },
   formControl: {
      width: '100%',
      height: 48,
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px',
      '&:not(:first-child)': {
         marginTop: '20px'
      }
   },
   buttonContainer: {
      margin: '10px 0px 10px 10px',
      paddingRight: '20px'
   },
   drawerContainer: {
      width: 500,
      padding: 20
   },
   Drawer: {
      '& .MuiDrawer-paper': {
         background: '#F9FAFC'
      }
   },
   drawerTitle: {
      fontSize: 22,
      fontWeight: 700
   }
}))

const RoleImport = () => {
   const classes = useStyles()

   const initialValues = {
      fileName: '',
      files: new FormData()
   }

   const [formData, setFormData] = useState(initialValues)
   const [showUpload, setShowUpload] = useState(false)
   const [isPopoverOpen, setIsPopoverOpen] = useState(false)
   const [loading, setLoading] = useState(false)
   const [, dispatch] = useStateValue()

   const IMPORTAR_ROL = useHasOperation(OPERACIONES_ROLES.IMPORTAR)

   const showUploadZone = () => {
      setShowUpload(state => !state)
   }

   const handleClean = () => {
      setFormData(initialValues)
   }

   const fileLoaded = file => {
      setFormData({
         fileName: file.length ? file[0].name : '',
         files: file
      })
      showUploadZone()
   }

   const handleSave = async () => {
      setLoading(true)
      const multipartFile = new FormData()
      for (const file of formData.files) {
         multipartFile.append('file', file)
      }
      await postToApi(
         `${process.env.REACT_APP_AUTHORIZATION_API}/config/import?importRoles=true`,
         multipartFile
      )
         .then(() => {
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message: 'Roles exportados correctamente!',
                  severity: 'success'
               }
            })
         })
         .catch(error => {
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message:
                     error?.message ||
                     'Lo sentimos, ha ocurrido un error importando el rol',
                  severity: 'error'
               }
            })
         })
      setLoading(false)
   }

   const RoleImportForm = () => (
      <>
         <Grid container>
            <div className={classes.formContainer}>
               <FormControl
                  required
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <InputLabel htmlFor="outlined-adornment-amount">
                     {formData.fileName.length > 0
                        ? formData.fileName
                        : 'Cargar/Subir Documento'}
                  </InputLabel>
                  <OutlinedInput
                     error={false}
                     value={formData.fileName}
                     onClick={showUploadZone}
                     label="Nombre de rol"
                     name="name"
                     size="small"
                     autoComplete="off"
                     disabled
                     endAdornment={
                        false ? (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 edge="end"
                                 style={{ marginRight: '3px' }}
                              >
                                 <InfoIcon fontSize="small" />
                              </IconButton>
                           </InputAdornment>
                        ) : (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 edge="end"
                                 style={{ marginRight: '3px' }}
                              >
                                 <CloudUploadIcon fontSize="small" />
                              </IconButton>
                           </InputAdornment>
                        )
                     }
                  />
               </FormControl>
            </div>
         </Grid>
         <Grid container direction="row" className={classes.buttonContainer}>
            <Grid item xs={12} sm={4} lg={4} xl={4} style={{ marginRight: 10 }}>
               <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClean}
                  fullWidth
               >
                  CANCELAR
               </Button>
            </Grid>
            <Grid item xs={12} sm={7} lg={7} xl={7} style={{ marginLeft: 15 }}>
               <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  fullWidth
                  disabled={!formData.files.length || !IMPORTAR_ROL}
               >
                  GUARDAR
               </Button>
            </Grid>
         </Grid>
      </>
   )

   return (
      <div>
         <Spinner open={loading} />
         <Drawer
            anchor="right"
            open={showUpload}
            onClose={showUploadZone}
            classes={classes.Drawer}
         >
            <Grid
               container
               direction="row"
               justify="flex-end"
               className={classes.drawerContainer}
            >
               <Grid item xs={12} sm={12} lg={12} xl={12}>
                  <p className={classes.drawerTitle}>
                     Importar Roles
                     <span
                        style={{ float: 'right', paddingRight: 10 }}
                        className="is-link"
                     >
                        <CloseIcon onClick={showUploadZone} />
                     </span>
                  </p>
               </Grid>
               <Grid item xs={12} sm={12} lg={12} xl={12}>
                  <DragZoneCard formats=".json" fileListCallback={fileLoaded} />
               </Grid>
            </Grid>
         </Drawer>
         <SecurityAdministrationLayout
            title="Importar Roles"
            form={<RoleImportForm />}
            popoverProp={isPopoverOpen}
            setPopoverProp={value => setIsPopoverOpen(value)}
         ></SecurityAdministrationLayout>
      </div>
   )
}

export default RoleImport
